import React, { useState } from "react";
import JapanPostalCode from "japan-postal-code";
import HeaderBox from "../../components/HeaderBox";
import Loading from "../../components/Loading";
import { Wrapper, Content, Row, MLabel, InputText, Line, InputDate, TextArea, Button, Footer, InputNumber } from './styles'
import { useSiteNew } from "./useSiteNew";
import PostalCodeSelectBox from "components/PostalCodeSelectBox";
import MessageBox from "components/MessageBox";
import { MESSAGE } from "Common";
import postalCodeApi from "api/postalCodeApi";

const dNow = new Date();
const dNowStr = `${dNow.getFullYear()}-${(dNow.getMonth() + 1).toString().padStart(2, '0')}-${dNow.getDate().toString().padStart(2, '0')}`;

const SiteNew = ({ hiddenHeader = false, handleSaveSite = null }) => {
    const [siteName, setSiteName] = useState('');
    const [siteKana, setSiteKana] = useState('');
    const [dateBeginning, setDateBeginning] = useState(dNowStr);
    const [dateFinished, setDateFinished] = useState(dNowStr);
    const [postalCode, setPostalCode] = useState('');
    const [siteAddr, setSiteAddr] = useState('');
    const [tel, setTel] = useState('');
    const [area, setArea] = useState(0);
    const [siteMemo, setSiteMemo] = useState('');
    const [showGetPostalCode, setShowGetPostalCode] = useState(false);
    const [adrList, setAdrList] = useState([]);
    const [message, setMessage] = useState({});


    const { setSiteInfo, isLoading, setIsLoading } = useSiteNew(handleSaveSite);

    const validate = () => {
        let msg = '';
        const dateStart = new Date(dateBeginning);
        const dateEnd = new Date(dateFinished);
        //SiteName
        if (!siteName.trim()) {
            msg = '現場名は入力必須項目です。';
        } else if (dateStart >= dateEnd) {
            msg = '期間指定開始日または最後日の日付範囲が正しくありません';
        }

        if (msg) {
            alert(msg);
            return false;
        }
        return true;
    }


    const handlePostCode = () => {
        if (!postalCode) return;
        JapanPostalCode.get(postalCode, (addr) => {

            setSiteAddr(`${addr.prefecture} ${addr.city}${addr.area}`);
        })

    }

    const handleGetPostalCode = async () => {
        //validate siteAddr
        if (!siteAddr) {
            const msg = { type: MESSAGE.ERROR, contents: ['住所を入力してください'] };
            setMessage(msg);
            return;
        }
        //get postal code
        try {
            setIsLoading(true);
            const { data } = await postalCodeApi.getPostalCode({ adr: siteAddr });
            const dtPostalCode = data?.dtPostalCode ?? [];
            if (dtPostalCode.length === 0) {
                const msg = { type: MESSAGE.ERROR, contents: ['該当する住所が見つかりません'] };
                setMessage(msg);
            } else if (dtPostalCode.length === 1) {
                setPostalCode(dtPostalCode[0].PostalCode);
            } else {
                setAdrList(dtPostalCode);
                setShowGetPostalCode(true);
            }

        } catch (error) {
            const msg = { type: MESSAGE.ERROR, contents: [error.toString()] };
            setMessage(msg);

        } finally {
            setIsLoading(false);
        }
    }

    const handleRegister = () => {
        if (validate()) {
            setSiteInfo({
                siteName,
                siteKana,
                dateBeginning,
                dateFinished,
                postalCode,
                siteAddr,
                tel,
                area,
                siteMemo,
            })
        }
    }


    return (
        <Wrapper>
            {!hiddenHeader && (<>
                <Loading isLoading={isLoading} />
                <HeaderBox title="現場登録" haveCart={false} />
            </>
            )}

            <Content>
                <Row column>
                    <MLabel>現場名：</MLabel>
                    <InputText
                        maxLength={100}
                        textHolder={'現場名'}
                        value={siteName}
                        onChange={(e) => { setSiteName(e.target.value) }}
                    />
                </Row>
                <Row column>
                    <MLabel>カナ：</MLabel>
                    <InputText
                        maxLength={100}
                        textHolder={'カナ'}
                        value={siteKana}
                        onChange={(e) => { setSiteKana(e.target.value) }}
                    />

                </Row>
                <Row column>
                    <MLabel>開始日～最後日：</MLabel>
                    <Line>
                        <InputDate
                            min={dNowStr}
                            max={'2099-12-31'}
                            value={dateBeginning}
                            onChange={(e) => { setDateBeginning(e.target.value); }}
                        />
                        ～
                        <InputDate
                            min={dNowStr}
                            max={'2099-12-31'}
                            value={dateFinished}
                            onChange={(e) => { setDateFinished(e.target.value); }}
                        />
                    </Line>
                </Row>
                <Row column>
                    <MLabel>郵便番号：</MLabel>
                    <Line>
                        <InputText
                            width={'100px'}
                            maxLength={10}
                            value={postalCode}
                            onChange={(e) => { setPostalCode(e.target.value); }}
                        />
                        <Button onClick={handlePostCode}>住所入力</Button>
                        <Button onClick={handleGetPostalCode}>郵便番号検索</Button>
                    </Line>
                </Row>
                <Row column>
                    <MLabel>住所：</MLabel>
                    <TextArea
                        maxLength={200}
                        rows={2}
                        value={siteAddr}
                        onChange={(e) => { setSiteAddr(e.target.value); }}
                    />
                </Row>
                <Row column>
                    <MLabel>ＴＥＬ：</MLabel>
                    <InputText
                        width={'150px'}
                        maxLength={50}
                        value={tel}
                        onChange={(e) => { setTel(e.target.value); }}
                    />
                </Row>
                <Row column>
                    <MLabel>面積：</MLabel>
                    <InputNumber
                        width={'100px'}
                        maxLength={10}
                        value={area}
                        onChange={(e) => { setArea(e.target.value); }}
                    />
                </Row>
                <Row column>
                    <MLabel>メモ(現場詳細、配達の際の注意事項があればご記入下さい)：</MLabel>
                    <TextArea
                        maxLength={300}
                        rows={4}
                        value={siteMemo}
                        onChange={(e) => { setSiteMemo(e.target.value); }}
                    />
                </Row>
                <Footer>
                    <Button onClick={() => { handleRegister(); }}>登録</Button>
                </Footer>
            </Content>
            <MessageBox message={message} setMessage={setMessage} />
            <PostalCodeSelectBox show={showGetPostalCode}
                setShow={setShowGetPostalCode}
                resultList={adrList}
                renderItem={(item) => { return `${item.Pref} ${item.City}${item.Number}` }}
                selectItem={(item) => { setPostalCode(item.PostalCode); setSiteAddr(`${item.Pref} ${item.City}${item.Number}`) }} />
        </Wrapper>
    )
}

export default SiteNew;